import { atom } from "jotai";

// To enter into draft focus mode for a node, set this atom to the node id
export const draftFocusNodeIdAtom = atom<string | null>(null);
draftFocusNodeIdAtom.debugLabel = "draftFocusNodeIdAtom";
